import React from 'react';
import { Field, useField } from 'formik';

import { FORM_ELEMENT } from '../constants';

const DecimalField = ({ ...props }) => {
    const [field] = useField(props);

    return <Field type="number" {...field} {...props} />;
};

DecimalField.propTypes = {
    ...FORM_ELEMENT,
};

export { DecimalField };
